import React from 'react';

const About = () => {
  return (
    <div className='bg-theme'>
      <div className='container'>
        <div className='row px-3 justify-content-between'>
          <div className='col-lg-6 text-white py-5'>
            <div className='px-2'>
            <div className='px-lg-5 px-xxl-2'>
              <h1 className='text-center font-weight-bold mb-4'>
                Bull or Bear
              </h1>
              <h3 className='text-center mb-5'>
                Discover your next profitable investment strategy
              </h3>
            </div>
            <div className='text-center'>
              <img
                src={require('../../resources/1. What is UOA-small.jpg').default}
                height='336'
                className='mw-100 rounded-xl'
                alt=''
              />
            </div>
            </div>
          </div>
          <div className='col-lg-6 text-white py-5'>
          <div className="px-2">
          <h1 className='text-center font-weight-bold mb-4'>About Us</h1>
            <p className='mont'>
              We are a team of ordinary investors that believe accessing data
              shouldn't be costly or complicated. After trying multiple paid
              service to obtain unusual option activity (UOA) data, we decided
              to create our own tracker and share our service with everyone.
            </p>
            <p className='mont'>
              We are excited to aid in the development of your investment
              strategy and help you achieve your financial goals. We, at
              OptionFalcon, will continue develop and add more features to our
              site to help you get the best data possible.
            </p>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
